import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { settings: () => import('./SettingsPage.vue') },
} satisfies FeatureRoutes
